import Modal from "../../../../../components/Modal";
import ObjectsTable from "./ObjectsTable";

export default function PreviewModal({
  isModalOpen,
  toggleModal,
  objects,
  saveObjects,
  ...props
}) {
  const handleConfirmation = () => {
    saveObjects(objects);
    toggleModal();
  };

  return (
    <Modal isOpen={isModalOpen} size="xl">
      <div className="d-flex flex-column p-4">
        <div className="d-flex w-100 justify-content-between w-100 border-1 border-bottom">
          <h5 className="fw-semibold text-primary">Objects Preview</h5>
        </div>
        <div className="overflow-y-auto">
          <ObjectsTable objects={objects} {...props} />
        </div>
        <div className="d-flex justify-content-center gap-2 mt-2 col-12 col-md-6 col-lg-4 align-self-end">
          <button className="btn btn-light flex-grow-1" onClick={toggleModal}>
            Close
          </button>
          <button
            className="btn btn-primary flex-grow-1"
            onClick={handleConfirmation}
            style={{ backgroundColor: "#14213D" }}
            disabled={objects.length === 0}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
}
